var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c(
      "div",
      { staticClass: "main-container", attrs: { id: "main-container" } },
      [
        _c("div", { attrs: { id: "notFound" } }, [
          _c("div", { staticClass: "center" }, [
            _c("img", { attrs: { src: _vm.mainImg, alt: "" } }),
            _vm._v(" "),
            _c("p", [_vm._v("咦？链接失效了呢")])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }